<template>
	<div>
		<b-modal
			id="filter-modal"
			header-class="bg-sinarmas"
			size="md"
			no-close-on-backdrop
			hide-footer
			@hide="$store.dispatch('filter/toggleShowFilter')"
		>
			
			<template v-slot:modal-header="{ close }">
				<div class="w-100 d-flex align-items-center justify-content-between">
					<span class="text-white font-weight-bold">Add Filter</span>

					<a @click.prevent="close" href="javascript:void(0);" class="btn btn-transparent"><i class="material-icons font-weight-bold text-white" style="font-size: 18px; vertical-align: middle;">close</i></a>
				</div>
			</template>

			<div class="top-button-container">
				<b-button class="mt-1 mb-2 btn-apply" variant="primary" text="white" @click="addAllFilter">Select All</b-button>
				<b-button class="mt-1 mb-2 btn-apply" variant="primary" text="white" @click="resetAllFilter">Reset</b-button>
				<b-button class="mt-1 mb-2 btn-apply" variant="primary" text="white" @click="applyFilters">Add Filter</b-button>
			</div>

			<b-list-group>
				<b-list-group-item
					v-for="item in itemFilterBox()"
					:key="item.label || item.id"
					:active="$store.state.datatable.selectedFilters.indexOf(item) > -1"
					@click="addFilter(item)"
					style="cursor: pointer; height : 2.2rem; display:flex; align-items:center"
				>
					<div style="font-size: .9rem;">
						{{ item.label }}
					</div>
				</b-list-group-item>
			</b-list-group>

				<div class="d-flex align-items-start justify-content-end w-100">
					<b-button class="mt-3 btn-apply" variant="primary" text="white" @click="applyFilters">Add Filter</b-button>
				</div>
	  </b-modal>
	</div>
</template>

<script>
import {filterCategory} from '../store/data'
export default {
	name: 'FilterSetting',
	data() {
		return {
			selectedFilters: [],
			itemToFilter: null,
		}
	},
	methods: {
		itemFilterBox(){
				const self = this
				return self.$store.state.permissions.filter
		},
		addFilter(item) {
			const self = this
			if (self.$store.state.datatable.selectedFilters.indexOf(item) > -1) {
				const filteredItems = self.$store.state.datatable.selectedFilters.filter(data => {
					if (data !== item) {
						return item
					}
				})
				self.$store.dispatch('datatable/addFilter', filteredItems)
			} else {
				self.$store.dispatch('datatable/pushFilter', item)
			}
			this.$ga.event({
				eventCategory: 'Filter Item',
				eventAction: 'click',
				eventLabel: item
			});
		},
		addAllFilter(){
			const self = this
			self.$store.dispatch('datatable/addAllFilter', self.itemFilterBox())
			this.$ga.event({
				eventCategory: 'Add Filter',
				eventAction: 'click',
				eventLabel: 'SELECT ALL'
			});
		},
		resetAllFilter(){
			const self = this
			self.$store.dispatch('datatable/resetAllFilter')
			this.$ga.event({
				eventCategory: 'Add Filter',
				eventAction: 'click',
				eventLabel: 'RESET'
			});
		},
		async applyFilters() {
			const self = this
			await self.$store.dispatch('datatable/setFilterField', self.$store.state.datatable.selectedFilters)
				.then(self.$bvModal.hide('filter-modal'))
			this.$ga.event({
				eventCategory: 'Add Filter',
				eventAction: 'click',
				eventLabel: 'ADD FILTER'
			});
			
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/filter-setting.scss';
</style>
